import { render, staticRenderFns } from "./chooseHouseTree.vue?vue&type=template&id=08f905e0&"
import script from "./chooseHouseTree.vue?vue&type=script&lang=js&"
export * from "./chooseHouseTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08f905e0')) {
      api.createRecord('08f905e0', component.options)
    } else {
      api.reload('08f905e0', component.options)
    }
    module.hot.accept("./chooseHouseTree.vue?vue&type=template&id=08f905e0&", function () {
      api.rerender('08f905e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/attractManage/attractCustomers/chooseHouseTree.vue"
export default component.exports